import * as React from 'react';

import { ShippingCostMethod } from 'root/apps/PurchaseOrder/LandedCostControl/types';

interface ShipCostHandlerProps {
  shippingCostMethod: ShippingCostMethod;
  shippingMethodSelect: HTMLSelectElement;
  shipCostStaticText: HTMLDivElement;
  shipCostInput: HTMLInputElement;
}

export const ShipCostHandler: React.FC<ShipCostHandlerProps> = ({
  shippingCostMethod: _shippingCostMethod,
  shippingMethodSelect,
  shipCostStaticText,
  shipCostInput,
}) => {
  const [shippingCostMethod, setShippingCostMethod] =
    React.useState<ShippingCostMethod>(_shippingCostMethod);

  const [shipCostInputWrapper] = React.useState<HTMLElement>(
    (shipCostInput.closest('.money-field-container') as HTMLElement | null) || shipCostInput
  );

  const [shipCostInputName] = React.useState<string>(shipCostInput.getAttribute('name') || '');
  const [shipCostInputID] = React.useState<string>(shipCostInput.getAttribute('id') || '');

  // Bind onchange event to select elements
  React.useEffect(() => {
    shippingMethodSelect.addEventListener('change', () => {
      const shippingMethod = shippingMethodSelect.value as ShippingCostMethod;
      setShippingCostMethod(shippingMethod);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Alter UI based on shipping method
  React.useEffect(() => {
    const resetUI = () => {
      shipCostStaticText.classList.remove('hidden');
      shipCostInputWrapper.classList.add('hidden');
      shipCostInput.setAttribute('name', `${shipCostInputName}--ignored`);
      shipCostInput.setAttribute('id', `${shipCostInputID}--ignored`);
    };
    const handleShippingMethod = () => {
      switch (shippingCostMethod) {
        case 'total':
          shipCostStaticText.classList.add('hidden');
          shipCostInputWrapper.classList.remove('hidden');
          shipCostInput.setAttribute('name', shipCostInputName);
          shipCostInput.setAttribute('id', shipCostInputID);
          break;
        case 'evenly':
        case 'proportionally':
        default:
          break;
      }
      shippingMethodSelect.value = shippingCostMethod;
    };
    const updateUI = () => {
      // call order matters
      resetUI();
      handleShippingMethod();
    };

    updateUI();
  }, [
    shippingCostMethod,
    shippingMethodSelect,
    shipCostStaticText,
    shipCostInputWrapper,
    shipCostInput,
    shipCostInputName,
    shipCostInputID,
  ]);

  return null;
};
